export enum TaxClass {
    Standard = 'STANDARD_TAX_RATE',
    Reduced1 = 'REDUCED_1_TAX_RATE',
    Reduced2 = 'REDUCED_2_TAX_RATE',
    Reduced3 = 'REDUCED_3_TAX_RATE',
}
